export default __webpack_public_path__ + "static/media/bathroom1-before.825cf857.jpg";